export const EMAIL_CUSTOMIZATION_QUERY_KEY = "emailCustomization";
